import uuid from "react-uuid";
import {
  deepCopy,
  getBrands,
  getCombinedDate,
  getDefaultCompBrand,
  getDefaultDuration,
  getDiscardedFilters,
  getTemporaryWordWidgetId,
  getTemporaryWords,
  getTimeIntervalDate,
} from ".";
export const removeParam = (parameter, url) => {
  let urlparts = url.split("?");

  if (urlparts.length >= 2) {
    let urlBase = urlparts.shift();
    let queryString = urlparts.join("?");

    let prefix = encodeURIComponent(parameter) + "=";
    let pars = queryString.split(/[&;]/g);
    for (let i = pars.length; i-- > 0; )
      if (pars[i].lastIndexOf(prefix, 0) !== -1) pars.splice(i, 1);
    url = urlBase + "?" + pars.join("&");
  }
  return url;
};
export const getUniqueValues = (values) => {
  if (values && Array.isArray(values)) {
    const uniqueValues = Array.from(values).filter(
      (value, index, self) => self.indexOf(value) === index
    );
    return uniqueValues;
  } else {
    return values;
  }
};

export const getGlobalScreenBrandsValue = (
  authParams,
  stateContainer,
  screen_id,
  quick_filter
) => {
  let selectedBrands = null;
  let defaultSingleBrand = getBrands(
    stateContainer?.logicalBrands,
    [stateContainer?.singleBrands?.[0]],
    stateContainer?.singleBrands,
    null
  );
  let defaultLogicalBrand = getBrands(
    stateContainer?.logicalBrands,
    null,
    stateContainer?.singleBrands,
    [stateContainer?.logicalBrands?.[0]]
  );
  let defaultCompBrand =
    stateContainer?.competitorBrands?.length > 0
      ? getDefaultCompBrand(stateContainer?.competitorBrands)
      : null;

  if (authParams) {
    if (
      //ticket dashboards
      stateContainer?.screen_type === "ticket"
    ) {
      if (
        //global single brands
        stateContainer?.global_dashboard_single_brands
      ) {
        selectedBrands = stateContainer?.global_dashboard_single_brands;
      } else {
        //clear other pane brands(logical,comp) for ticket dashboards
        selectedBrands = defaultSingleBrand;
      }
    } else {
      //other dashboards
      //to set default comp brands in competiiton benchmark dashboard
      if (authParams?.brandID) {
        let obj = getBrands(
          stateContainer?.logicalBrands,
          [{ brand_id: authParams?.brandID }],
          stateContainer?.singleBrands,
          null
        );

        selectedBrands = obj?.columns
          ? obj?.columns
          : [{ brand_id: authParams?.brandID }];
      } else if (
        stateContainer?.screen_type === "competition" &&
        (!stateContainer?.global_dashboard_brands ||
          (stateContainer?.global_dashboard_brands &&
            !stateContainer?.global_dashboard_brands?.columns?.[0]?.competitor))
      ) {
        if (!authParams?.filterScreen)
          selectedBrands = defaultCompBrand
            ? defaultCompBrand
            : defaultSingleBrand;
      } else if (stateContainer?.global_dashboard_brands) {
        //to set global normal brands
        if (
          //to not update screen brands if benchmark screen is opened
          (stateContainer?.global_dashboard_brands?.columns?.[0]?.competitor &&
            stateContainer?.screen_type === "competition") ||
          stateContainer?.screen_type !== "competition"
        ) {
          if (
            stateContainer?.global_dashboard_brands?.columns?.[0]?.competitor &&
            stateContainer?.screen_type !== "competition" &&
            !authParams?.filterScreen
          ) {
            selectedBrands = stateContainer?.global_dashboard_single_brands //if global single brands then add it to screen (formatting is diff)
              ? [stateContainer?.global_dashboard_single_brands?.columns]
              : defaultLogicalBrand?.columns?.length && !quick_filter
              ? defaultLogicalBrand
              : defaultSingleBrand?.columns?.length
              ? defaultSingleBrand
              : null;
          } else if (quick_filter) {
            selectedBrands =
              !stateContainer?.global_dashboard_brands?.columns?.[0]?.group &&
              stateContainer?.global_dashboard_brands?.columns?.length
                ? {
                    columns: [
                      stateContainer?.global_dashboard_brands?.columns?.[0],
                    ],
                    attribute: "BrandID",
                    type: "varchar",
                  }
                : stateContainer?.global_dashboard_single_brands //if global single brands then add it to panes (formatting is diff)
                ? [stateContainer?.global_dashboard_single_brands?.columns]
                : defaultSingleBrand;
          } else {
            selectedBrands = stateContainer?.global_dashboard_brands;
          }
        }
      } else {
        if (stateContainer?.global_dashboard_single_brands) {
          //if global single brands then add it to screen (formatting is diff)
          selectedBrands = [
            stateContainer?.global_dashboard_single_brands?.columns,
          ];
        } else {
          selectedBrands =
            defaultLogicalBrand?.columns?.length && !quick_filter
              ? defaultLogicalBrand
              : defaultSingleBrand?.columns?.length
              ? defaultSingleBrand
              : null;
        }
      }
    }
  } else if (quick_filter) {
    if (
      stateContainer?.global_dashboard_brands &&
      stateContainer?.global_dashboard_brands?.columns &&
      stateContainer?.global_dashboard_brands?.columns?.length > 0 &&
      !stateContainer?.global_dashboard_brands?.columns?.[0]?.group &&
      !stateContainer?.global_dashboard_brands?.columns?.[0]?.competitor
    ) {
      selectedBrands = {
        columns: stateContainer?.global_dashboard_brands?.columns?.length
          ? [stateContainer?.global_dashboard_brands?.columns?.[0]]
          : [],
        attribute: "BrandID",
        type: "varchar",
      };
    } else if (stateContainer?.global_dashboard_single_brands) {
      //if global single brands then add it to screen (formatting is diff)
      selectedBrands = [
        stateContainer?.global_dashboard_single_brands?.columns,
      ];
    } else {
      selectedBrands = defaultSingleBrand;
    }
  } else if (screen_id) {
    //on dashbaord reload and dashboard open
    if (
      stateContainer?.screen?.screen_type === "ticket" ||
      stateContainer?.screen_type === "ticket"
    ) {
      if (
        stateContainer?.global_dashboard_brands ||
        stateContainer?.global_dashboard_single_brands
      ) {
        if (stateContainer?.global_dashboard_single_brands) {
          selectedBrands = stateContainer?.global_dashboard_single_brands;
        } else if (stateContainer?.global_dashboard_brands?.columns?.brand_id) {
          // this belongs to SingleBrand component
          selectedBrands = stateContainer?.global_dashboard_brands;
        } else {
          selectedBrands = defaultSingleBrand;
        }
      } else {
        selectedBrands = defaultSingleBrand;
      }
    } else if (stateContainer?.global_dashboard_brands) {
      if (
        stateContainer?.screen_type === "competition" ||
        (stateContainer?.screen_type
          ? stateContainer?.screen_type === "competition" &&
            stateContainer?.screen &&
            stateContainer?.screen?.screen_type === "competition"
          : stateContainer?.screen &&
            stateContainer?.screen?.screen_type === "competition")
      ) {
        if (
          stateContainer?.global_dashboard_brands?.columns?.[0]?.competitor ||
          stateContainer?.global_dashboard_brands?.competitor
        ) {
          selectedBrands = stateContainer?.global_dashboard_brands;
        } else {
          // if (defaultCompBrand) paneObject.selectBrands = defaultCompBrand;
          selectedBrands = defaultCompBrand
            ? defaultCompBrand
            : defaultSingleBrand;
        }
      } else {
        if (
          stateContainer?.global_dashboard_brands?.columns?.[0]?.competitor ||
          stateContainer?.global_dashboard_brands?.competitor
        ) {
          selectedBrands = defaultLogicalBrand?.columns?.length
            ? defaultLogicalBrand
            : defaultSingleBrand?.columns?.length
            ? defaultSingleBrand
            : null;
        } else selectedBrands = stateContainer?.global_dashboard_brands;
      }
    } else if (
      stateContainer?.screen_type === "competition" ||
      (stateContainer?.screen_type
        ? stateContainer?.screen_type === "competition" &&
          stateContainer?.screen &&
          stateContainer?.screen?.screen_type === "competition"
        : stateContainer?.screen &&
          stateContainer?.screen?.screen_type === "competition")
    ) {
      selectedBrands = defaultCompBrand ? defaultCompBrand : defaultSingleBrand;
    } else {
      selectedBrands = defaultLogicalBrand?.columns?.length
        ? defaultLogicalBrand
        : defaultSingleBrand?.columns?.length
        ? defaultSingleBrand
        : null;
    }
  }

  return selectedBrands;
};
export const getAllWidgetScreenFilters = (
  screen,
  section_index,
  widget_index,
  brands,
  logicalBrands,
  widgetObj,
  sectionObj
) => {
  let GlobalFilter = screen?.filters ? screen?.filters : [];
  let hiddenFilter = screen?.hidden_filter ? [screen?.hidden_filter] : [];
  let quickFilter = screen?.selected_quick_profile
    ? [
        {
          attribute: screen?.selected_quick_profile?.attribute,
          type: screen?.selected_quick_profile?.type,
          columns: screen?.selected_quick_profile?.columns,
        },
      ]
    : [];
  let getFilters = sectionObj
    ? sectionObj?.brand_ids || sectionObj?.brand_groups
      ? getBrands(
          logicalBrands,
          sectionObj?.brand_ids ? sectionObj?.brand_ids : null,
          brands,
          sectionObj?.brand_groups ? sectionObj?.brand_groups : null
        )
      : null
    : screen?.sections
    ? getBrands(
        logicalBrands,
        screen?.sections?.[section_index]?.brand_ids
          ? screen?.sections?.[section_index]?.brand_ids
          : null,
        brands,
        screen?.sections?.[section_index]?.brand_groups
          ? screen?.sections?.[section_index]?.brand_groups
          : null
      )
    : null;
  let sectionBrandFilter = getFilters ? [getFilters] : [];
  let sectionDateFilter = sectionObj?.dateFilters
    ? sectionObj?.dateFilters
    : screen?.sections
    ? screen?.sections[section_index]?.dateFilters
      ? screen?.sections[section_index]?.dateFilters
      : []
    : screen?.section && screen?.section[0]?.dateFilters
    ? screen?.section[0]?.dateFilters
    : [];
  let sectionFilter = sectionObj?.filters
    ? sectionObj?.filters
    : screen?.sections
    ? screen?.sections[section_index]?.filters
      ? screen?.sections[section_index]?.filters
      : []
    : screen?.section && screen?.section[0]?.filters
    ? screen?.section[0]?.filters
    : [];
  // to filter section level date and brands filter if these are exits in sectionFilter
  sectionFilter = sectionFilter?.filter(
    (el) => el?.attribute !== "CreatedDate" && el?.attribute !== "BrandID"
  );

  let WidgetFilter = widgetObj?.filters ? widgetObj?.filters : [];

  // to filter widget level date and brands filter if these are exits in WidgetFilter
  WidgetFilter = WidgetFilter?.filter(
    (el) => el?.attribute !== "BrandID" && el?.attribute !== "CreatedDate"
  );
  let finalBrand_list =
    widgetObj?.brand_ids?.length > 0 || widgetObj?.brand_groups?.length > 0
      ? getBrands(
          logicalBrands,
          widgetObj?.brand_ids,
          brands,
          widgetObj?.brand_groups
        )
      : null;
  let WidgetBrandFilter = finalBrand_list ? [finalBrand_list] : [];
  let WidgetDateFilter = widgetObj?.duration?.from
    ? [
        {
          attribute: "CreatedDate",
          type: "datetime",
          columns: widgetObj?.duration,
        },
      ]
    : [];
  if (WidgetDateFilter?.length === 0) {
    if (screen?.sections || screen?.section) {
      if (
        (screen &&
          screen?.sections[section_index]?.widgets?.[widget_index]
            ?.dateFilters) ||
        (screen?.section &&
          screen?.section[0]?.widgets?.[widget_index]?.dateFilters)
      ) {
        WidgetDateFilter = screen?.sections
          ? screen?.sections[section_index]?.widgets?.[widget_index]
              ?.dateFilters
          : screen?.section[0]?.widgets?.[widget_index]?.dateFilters;
      } else if (
        (screen?.sections &&
          screen?.sections[section_index]?.widgets?.[widget_index]
            ?.start_date) ||
        (screen?.section &&
          screen?.section[0]?.widgets?.[widget_index]?.start_date)
      ) {
        WidgetDateFilter = [
          {
            attribute: "CreatedDate",
            type: "datetime",
            columns: {
              from: screen?.sections
                ? screen?.sections[section_index]?.widgets?.[widget_index]
                    ?.start_date
                : screen?.section[0]?.widgets?.[widget_index]?.start_date,
              to: screen?.sections
                ? screen?.sections[section_index]?.widgets?.[widget_index]
                    ?.end_date
                : screen?.section[0]?.widgets?.[widget_index]?.end_date,
            },
          },
        ];
      } else {
        WidgetDateFilter = [];
      }
    }
  }
  //combine all filters array to make final filter array
  let totalFilter = [];
  let isSectionLocked = sectionObj?.is_locked
    ? sectionObj?.is_locked
    : screen?.sections
    ? screen?.sections[section_index]?.is_locked
      ? screen?.sections[section_index]?.is_locked
      : false
    : screen?.section && screen?.section[0]?.is_locked
    ? screen?.section[0]?.is_locked
    : false;
  isSectionLocked = isSectionLocked ? isSectionLocked : false;
  let isWidgetLocked = widgetObj?.is_locked ? widgetObj?.is_locked : false;
  isWidgetLocked = isWidgetLocked ? isWidgetLocked : false;
  let widget_type = widgetObj?.type ? widgetObj?.type : false;
  let widget_data_source = widgetObj?.data_source
    ? widgetObj?.data_source
    : false;
  let widget_id = widgetObj?.widget_id ? widgetObj?.widget_id : false;
  widget_id = widget_id ? widget_id : false;
  widget_data_source = widget_data_source ? widget_data_source : false;
  widget_type = widget_type ? widget_type : false;

  if (isSectionLocked) {
    if (isWidgetLocked) {
      totalFilter = [...hiddenFilter, ...quickFilter, ...WidgetFilter];
    } else if (!isWidgetLocked) {
      let finalFilter = [...sectionFilter, ...WidgetFilter];

      totalFilter = [
        ...hiddenFilter,
        ...quickFilter,
        ...finalFilter,
        ...WidgetBrandFilter,
        ...WidgetDateFilter,
      ];
    }
  } else if (!isSectionLocked) {
    if (isWidgetLocked) {
      totalFilter = [...hiddenFilter, ...quickFilter, ...WidgetFilter];
    } else if (!isWidgetLocked) {
      let finalFilter = [];

      finalFilter = [...GlobalFilter, ...sectionFilter, ...WidgetFilter];
      totalFilter = [
        ...hiddenFilter,
        ...quickFilter,
        ...finalFilter,
        ...sectionBrandFilter,
        ...WidgetBrandFilter,
        ...sectionDateFilter,
        ...WidgetDateFilter,
      ];
    }
  }
  return totalFilter;
};

export const getScreenWidgetGraphObject = (rawData) => {
  let graphObject;
  const notResetOrderByForScreen = [
    "000-000-557",
    "000-000-554",
    "000-000-555",
    "000-000-559",
    "000-000-561",
    "000-000-562",
    "000-000-565",
  ]?.includes(rawData?.authParams?.screen_id)
    ? ["000-000-559", "000-000-561", "000-000-562", "000-000-565"]?.includes(
        rawData?.authParams?.screen_id
      ) && rawData?.globalChangeInprogress
      ? false
      : ["000-000-559"]?.includes(rawData?.authParams?.screen_id) &&
        rawData?.isRefreshEvent
      ? false
      : true
    : false;

  let Section_is_locked = rawData?.screen?.sections
    ? rawData?.screen?.sections?.[rawData?.section_index]?.is_locked
    : null;
  Section_is_locked = Section_is_locked ? Section_is_locked : false;
  let widgets_is_locked = rawData?.widget ? rawData?.widget?.is_locked : false;
  widgets_is_locked = widgets_is_locked ? widgets_is_locked : false;
  let defaultDuration = getDefaultDuration({ isCommandCenter: true });
  let sectionDateFilter = rawData?.screen?.sections
    ? {
        from: rawData?.screen?.sections?.[rawData?.section_index]?.start_date
          ? rawData?.screen?.sections?.[rawData?.section_index]?.start_date
          : null,
        to: rawData?.screen?.sections?.[rawData?.section_index]?.end_date
          ? rawData?.screen?.sections?.[rawData?.section_index]?.end_date
          : null,
      }
    : rawData?.screen?.section
    ? {
        from: rawData?.screen?.section?.[0]?.start_date
          ? rawData?.screen?.section?.[0]?.start_date
          : null,
        to: rawData?.screen?.section?.[0]?.end_date
          ? rawData?.screen?.section?.[0]?.end_date
          : null,
      }
    : null;
  let widgetFilterDate = rawData?.widget?.duration
    ? rawData?.widget?.duration?.from
      ? rawData?.widget?.duration
      : []
    : rawData?.screen?.sections
    ? {
        from: rawData?.widget?.start_date ? rawData?.widget?.start_date : null,
        to: rawData?.widget?.end_date ? rawData?.widget?.end_date : null,
      }
    : [];

  let widgetData = rawData?.widget;

  let sectionBrands =
    rawData?.sectionObj?.brand_ids || rawData?.sectionObj?.brand_groups
      ? getBrands(
          rawData?.brandlogicalgroup?.length > 0
            ? rawData?.brandlogicalgroup
            : rawData?.brands,
          rawData?.sectionObj?.brand_ids
            ? rawData?.sectionObj?.brand_ids
            : null,
          rawData?.brands,
          rawData?.sectionObj?.brand_groups
            ? rawData?.sectionObj?.brand_groups
            : null
        )
      : rawData?.sectionObj?.brandFilters
      ? rawData?.sectionObj?.brandFilters
      : getBrands(
          rawData?.brandlogicalgroup?.length > 0
            ? rawData?.brandlogicalgroup
            : rawData?.brands,
          rawData?.screen?.sections?.[rawData?.section_index]?.brand_ids,
          rawData?.brands,
          rawData?.screen?.sections?.[rawData?.section_index]?.brand_groups
        );
  let widgetBrands = widgetData?.brandFilters?.columns
    ? widgetData?.brandFilters
    : getBrands(
        rawData?.brandlogicalgroup?.length > 0
          ? rawData?.brandlogicalgroup
          : rawData?.brands,
        widgetData?.brand_ids,
        rawData?.brands,
        widgetData?.brand_groups
      );

  let paneObj = { temporary_words: rawData?.temporary_words };
  paneObj.template_id = rawData?.screen?.screen_id;
  paneObj.section_id = rawData?.screen?.sections
    ? rawData?.screen?.sections?.[rawData?.section_index]?.section_id
    : rawData?.screen?.section?.[0]?.section_id
    ? rawData?.screen?.section?.[0]?.section_id
    : rawData?.screen?.section_id;
  paneObj.widget_id = widgetData?.widget_id
    ? widgetData?.widget_id
    : rawData?.screen?.sections
    ? rawData?.screen?.sections?.[rawData?.section_index]?.widgets?.[
        rawData?.widget_index
      ]?.widget_id
    : rawData?.screen?.section?.[0]?.widgets?.[rawData?.widget_index]
        ?.widget_id;
  //for exploded wordcloud by comptitor brands
  if (widgetData?.duplicate_for_brands) {
    paneObj.widget_id = getTemporaryWordWidgetId(widgetData);
  }
  let temp_exclude_words = getTemporaryWords(paneObj);
  temp_exclude_words = getUniqueValues(temp_exclude_words);

  let finalExcludeWords =
    rawData?.exclude_words && !widgetData?.duplicate_for_brands
      ? widgetData?.exclude_words
        ? [...rawData?.exclude_words, ...widgetData?.exclude_words]
        : [...rawData?.exclude_words]
      : temp_exclude_words &&
        widgetData?.exclude_words &&
        !widgetData?.duplicate_for_brands
      ? [...temp_exclude_words, ...widgetData?.exclude_words]
      : !widgetData?.duplicate_for_brands && widgetData?.exclude_words
      ? [...widgetData?.exclude_words]
      : temp_exclude_words
      ? [...temp_exclude_words]
      : [];

  finalExcludeWords = getUniqueValues(finalExcludeWords);
  let updatedOrderBy;
  if (widgetData?.order_by) {
    updatedOrderBy = {
      ...widgetData?.order_by,
      offset: notResetOrderByForScreen ? widgetData?.order_by?.offset : 0,
    };
  }

  // console.log("main rawData", rawData);

  let updatedFilter = getDiscardedFilters(rawData);
  // this is used for brand filter selectedtion like date aggregation
  let widgetSingleBrandFilter = widgetData?.widgetSingleBrandFilter?.brand_id
    ? [
        {
          brand_id: widgetData?.widgetSingleBrandFilter?.brand_id,
          brand_name: widgetData?.widgetSingleBrandFilter?.brand_name,
          brand_friendly_name:
            widgetData?.widgetSingleBrandFilter?.brand_friendly_name,
        },
      ]
    : null;
  if (
    rawData?.graphConditionConfig?.[`data-source`]?.includes(
      widgetData?.data_source
    ) ||
    widgetData?.x_axis ||
    widgetData?.y_series ||
    widgetData?.chart
  ) {
    graphObject = {
      start_date: widgetData?.is_locked
        ? widgetData?.start_date
          ? widgetData?.start_date
          : widgetFilterDate?.from
          ? widgetFilterDate?.from
          : Section_is_locked
          ? sectionDateFilter?.from
            ? sectionDateFilter?.from
            : rawData?.duration?.from
            ? rawData?.duration?.from
            : defaultDuration?.from
          : rawData?.duration?.from
          ? rawData?.duration?.from
          : defaultDuration?.from
        : Section_is_locked
        ? sectionDateFilter?.from
          ? sectionDateFilter?.from
          : rawData?.duration?.from
          ? rawData?.duration?.from
          : defaultDuration?.from
        : rawData?.duration?.from
        ? rawData?.duration?.from
        : defaultDuration?.from,
      end_date: widgetData?.is_locked
        ? widgetData?.end_date
          ? widgetData?.end_date
          : widgetFilterDate?.to
          ? widgetFilterDate?.to
          : Section_is_locked
          ? sectionDateFilter?.to
            ? sectionDateFilter?.to
            : rawData?.duration?.to
            ? rawData?.duration?.to
            : defaultDuration?.to
          : rawData?.duration?.to
          ? rawData?.duration?.to
          : defaultDuration?.to
        : Section_is_locked
        ? sectionDateFilter?.to
          ? sectionDateFilter?.to
          : rawData?.duration?.to
          ? rawData?.duration?.to
          : defaultDuration?.to
        : rawData?.duration?.to
        ? rawData?.duration?.to
        : defaultDuration?.to,
      brands: widgetSingleBrandFilter
        ? widgetSingleBrandFilter
        : widgets_is_locked
        ? widgetBrands?.columns
          ? widgetBrands?.columns
          : Section_is_locked
          ? sectionBrands?.columns
            ? sectionBrands?.columns
            : widgetData?.duplicate_for_brands
            ? widgetData?.com_brand_ids
            : rawData?.global_brands
            ? rawData?.global_brands
            : rawData?.brandlogicalgroup?.length
            ? rawData?.brandlogicalgroup
            : rawData?.brands
          : widgetData?.duplicate_for_brands
          ? widgetData?.com_brand_ids
          : rawData?.global_brands
          ? rawData?.global_brands
          : rawData?.brandlogicalgroup?.length
          ? rawData?.brandlogicalgroup
          : rawData?.brands
        : Section_is_locked
        ? sectionBrands?.columns
          ? sectionBrands?.columns
          : widgetData?.duplicate_for_brands
          ? widgetData?.com_brand_ids
          : rawData?.global_brands
          ? rawData?.global_brands
          : rawData?.brandlogicalgroup?.length
          ? rawData?.brandlogicalgroup
          : rawData?.brands
        : widgetData?.duplicate_for_brands
        ? widgetData?.com_brand_ids
        : rawData?.global_brands
        ? rawData?.global_brands
        : rawData?.brandlogicalgroup?.length
        ? rawData?.brandlogicalgroup
        : rawData?.brands,

      order_by: !rawData?.offset_flag ? updatedOrderBy : widgetData?.order_by,
      offset_flag: rawData?.offset_flag,
      filters: rawData?.category_screen_filters?.length
        ? rawData?.country_state_city_filters?.length
          ? [
              ...rawData?.filter,
              ...rawData?.category_screen_filters,
              ...rawData?.country_state_city_filters,
            ]
          : [...rawData?.filter, ...rawData?.category_screen_filters]
        : rawData?.filter
        ? rawData?.country_state_city_filters?.length
          ? [...rawData?.filter, ...rawData?.country_state_city_filters]
          : rawData?.filter
        : null,
      x_axis: widgetData?.x_axis,
      // Break down data
      y_axes: widgetData?.y_axes,
      // y axis data
      y_series: widgetData?.y_series,
      widget_name: widgetData?.widget_name,
      chart: widgetData?.chart,
      comp_brand_list:
        (!widgets_is_locked &&
          !(widgetData?.brand_ids || widgetData?.brand_groups) &&
          widgetData?.duplicate_for_brands) ||
        (!Section_is_locked &&
          !(
            rawData?.screen?.sections?.[rawData?.section_index]?.brand_ids ||
            rawData?.screen?.sections?.[rawData?.section_index]?.brand_groups
          ) &&
          widgetData?.duplicate_for_brands)
          ? null
          : widgetData?.comp_brand_list,
      data_source: widgetData?.data_source,
      widget_id: widgetData?.widget_id,
      engine: widgetData?.engine,
      ticket: widgetData?.data_source === "ticket" ? true : false,
      feedback: widgetData?.data_source === "feedback" ? true : false,
      nps: widgetData?.data_source === "nps" ? true : false,
      campaign: widgetData?.data_source === "campaign" ? true : false,
      exclude_words: finalExcludeWords,
      temp_exclude_words: temp_exclude_words,
      graphConditionConfig: rawData?.graphConditionConfig,
      filter_by: rawData?.filter_by ? rawData?.filter_by : null,
      filter_by_data: rawData?.filter_by_data ? rawData?.filter_by_data : null,
      multilevel_breakdown: widgetData?.multilevel_breakdown || null,
    };
  } else {
    graphObject = {
      authParams: rawData?.authParams,
      firstAttr: widgetData?.primary,
      secondAttr: widgetData?.secondary,
      filterObj: rawData?.filter ? rawData?.filter : null,
      splitObj: widgetData?.splits,
      brands: widgets_is_locked
        ? widgetBrands?.columns
          ? widgetBrands?.columns
          : Section_is_locked
          ? sectionBrands?.columns
            ? sectionBrands?.columns
            : rawData?.global_brands
            ? rawData?.global_brands
            : rawData?.brandlogicalgroup?.length
            ? rawData?.brandlogicalgroup
            : rawData?.brands
          : rawData?.global_brands
          ? rawData?.global_brands
          : rawData?.brandlogicalgroup?.length
          ? rawData?.brandlogicalgroup
          : rawData?.brands
        : Section_is_locked
        ? sectionBrands?.columns
          ? sectionBrands?.columns
          : rawData?.global_brands
          ? rawData?.global_brands
          : rawData?.brandlogicalgroup?.length
          ? rawData?.brandlogicalgroup
          : rawData?.brands
        : rawData?.global_brands
        ? rawData?.global_brands
        : rawData?.brandlogicalgroup?.length
        ? rawData?.brandlogicalgroup
        : rawData?.brands,
      base: widgetData?.base,
      duration: widgets_is_locked
        ? widgetFilterDate?.from
          ? widgetFilterDate
          : Section_is_locked
          ? sectionDateFilter?.from
            ? sectionDateFilter
            : rawData?.duration
            ? rawData?.duration
            : defaultDuration
          : rawData?.duration
          ? rawData?.duration
          : defaultDuration
        : Section_is_locked
        ? sectionDateFilter?.from
          ? sectionDateFilter
          : rawData?.duration
          ? rawData?.duration
          : defaultDuration
        : rawData?.duration?.from
        ? rawData?.duration
        : defaultDuration,
      widget_id: widgetData?.widget_id,
      percent: widgetData?.percent,
      exclude_words: finalExcludeWords,
      temp_exclude_words: temp_exclude_words,
      graph_type: widgetData?.graph_type,
      filter_by: rawData?.filter_by ? rawData?.filter_by : null,
      filter_by_data: rawData?.filter_by_data ? rawData?.filter_by_data : null,
    };
  }

  let global_date = {
    from: graphObject?.start_date,
    to: graphObject?.end_date,
  };
  let filter_date = [];
  // because we already passing start_date or end_date of widget in graphObject Based on locking filter so don't need to pass
  // graphObject?.filters?.filter?.((d) => {
  //   if (d.attribute === "CreatedDate") {
  //     filter_date = [...filter_date, d?.columns];
  //   }
  // });
  let combinedDate = getCombinedDate(global_date, filter_date);
  let getInterval = getTimeIntervalDate(
    combinedDate?.end_date,
    combinedDate?.start_date,
    graphObject?.data_source,
    graphObject?.x_axis?.attribute
  );

  if (
    (graphObject?.chart?.chart_type === "grid" &&
      graphObject?.data_source == "ticket" &&
      rawData?.graphConditionConfig &&
      rawData?.graphConditionConfig?.[`date-attributes`]?.includes(
        graphObject?.x_axis?.attribute
      )) ||
    ((graphObject?.x_axis?.date_part === null ||
      graphObject?.x_axis?.date_part === "D") &&
      rawData?.graphConditionConfig?.[`date_agg-chart_type`]?.includes(
        graphObject?.chart?.chart_type
      ) &&
      rawData?.graphConditionConfig &&
      rawData?.graphConditionConfig?.[`date-attributes`]?.includes(
        graphObject?.x_axis?.attribute
      ))
  ) {
    graphObject.x_axis.date_aggregation =
      getInterval?.defaultVal === "D" ? null : getInterval?.defaultVal;
  }
  if (
    (rawData?.graphConditionConfig &&
      graphObject?.chart?.chart_type === "pivot-grid" &&
      graphObject?.data_source === "ticket") ||
    rawData?.graphConditionConfig?.[`date_agg-chart_type`]?.includes(
      graphObject?.chart?.chart_type
    )
  ) {
    graphObject?.y_axes?.forEach((y_axis) => {
      if (
        rawData?.graphConditionConfig?.[`date-attributes`]?.includes(
          y_axis?.attribute
        ) &&
        (!y_axis?.date_part || y_axis?.date_part === "D")
      ) {
        y_axis.date_aggregation =
          getInterval?.defaultVal === "D" ? null : getInterval?.defaultVal;
      }
    });
  }

  graphObject.isBrandModified =
    rawData?.global_brands ||
    (widgets_is_locked &&
      (widgetBrands?.columns
        ? widgetBrands?.columns?.length
        : widgetBrands?.length)) ||
    (Section_is_locked &&
      (sectionBrands?.columns
        ? sectionBrands?.columns?.length
        : sectionBrands?.length)) ||
    widgetData?.duplicate_for_brands
      ? true
      : false;
  if (
    graphObject?.chart?.chart_type === "wordcloud" &&
    widgetData?.duplicate_for_brands
  ) {
    let indexOfCompWords = widgetData?.comp_exclude_words?.findIndex(
      (el) => el?.[graphObject?.brands?.[0]?.brand_id]
    );
    let parmanentExcluededWords = widgetData?.comp_exclude_words?.[
      indexOfCompWords
    ]?.[graphObject?.brands?.[0]?.brand_id]
      ? widgetData?.comp_exclude_words?.[indexOfCompWords]?.[
          graphObject?.brands?.[0]?.brand_id
        ]
      : [];

    graphObject.exclude_words = finalExcludeWords?.length
      ? [...finalExcludeWords, ...parmanentExcluededWords]
      : parmanentExcluededWords;
  }
  return graphObject;
};

export const getWidgetIdForScreenApiCalledList = (widget) => {
  let widgetId =
    widget?.widget_id + "#" + widget?.section_id + "#" + widget?.widget_index;
  return widgetId;
};
export const getUpdatedScreenApiCalledList = (
  called_api_list,
  widgetId,
  operation
) => {
  let update_called_api_list = called_api_list;
  if (operation === "ADD") {
    update_called_api_list = [...update_called_api_list, widgetId];
  } else if (operation === "REMOVE") {
    update_called_api_list = update_called_api_list?.filter(
      (d) => d !== widgetId
    );
  }
  return update_called_api_list;
};
export const getUpdatedScreenWidgetList = (
  screen,
  sectionIndex,
  widgetIndex,
  operation,
  graphData,
  body,
  graphObject,
  widget_id,
  isRefreshEvent = false,
  widgetRefreshId,
  presistDataStored = false
) => {
  const updateScreen = screen ? { ...screen } : {};
  let update_widget_list = [];
  if (operation === "ALL_CLEAR") {
    if (
      sectionIndex !== null &&
      updateScreen?.sections &&
      updateScreen?.sections?.[sectionIndex]?.widgets?.length > 0
    ) {
      update_widget_list = updateScreen.sections[sectionIndex].widgets?.map(
        (wid) => {
          if (
            isRefreshEvent &&
            widgetRefreshId &&
            Array.isArray(widgetRefreshId) &&
            (widgetRefreshId?.includes(wid?.widget_id) ||
              widgetRefreshId?.includes(wid?.parentId) ||
              widgetRefreshId?.includes(wid?.childId))
          ) {
            delete wid?.graphData;
          } else if (!isRefreshEvent) {
            delete wid?.graphData;
            delete wid?.persist_graphdata;
          }
          return wid;
        }
      );
    } else if (
      updateScreen?.section &&
      updateScreen?.section?.[0]?.widgets?.length > 0
    ) {
      update_widget_list = updateScreen?.section[0].widgets?.map((wid) => {
        if (
          isRefreshEvent &&
          widgetRefreshId &&
          Array.isArray(widgetRefreshId) &&
          (widgetRefreshId?.includes(wid?.widget_id) ||
            widgetRefreshId?.includes(wid?.parentId) ||
            widgetRefreshId?.includes(wid?.childId))
        ) {
          delete wid?.graphData;
        } else if (!isRefreshEvent) {
          delete wid?.graphData;
          delete wid?.persist_graphdata;
        }
        return wid;
      });
    } else if (updateScreen?.widgets && updateScreen?.widgets?.length > 0) {
      update_widget_list = updateScreen?.widgets?.map((wid) => {
        if (
          isRefreshEvent &&
          widgetRefreshId &&
          Array.isArray(widgetRefreshId) &&
          (widgetRefreshId?.includes(wid?.widget_id) ||
            widgetRefreshId?.includes(wid?.parentId) ||
            widgetRefreshId?.includes(wid?.childId))
        ) {
          delete wid?.graphData;
        } else if (!isRefreshEvent) {
          delete wid?.graphData;
          delete wid?.persist_graphdata;
        }

        if (
          screen?.screen_id === "000-000-562" ||
          screen?.screen_id === "000-000-565"
        ) {
          wid.oldGraphData = null;

          // For Pill bug
          wid.filter_by = null;
          wid.filter_by_data = null;
        } else if (
          screen?.screen_id === "000-000-555" ||
          screen?.screen_id === "000-000-554"
        ) {
          wid.stored_in_reserved_data = false;
          wid.reserved_data = null;
          wid.deletedTagId = null;
        }

        return wid;
      });
    }
  } else if (operation === "CLEAR") {
    if (
      sectionIndex !== null &&
      updateScreen?.sections &&
      updateScreen?.sections?.[sectionIndex]?.widgets?.[widgetIndex]
    ) {
      delete updateScreen.sections[sectionIndex]?.widgets[widgetIndex]
        ?.graphData;
      const removePresistGraphData = updateScreen?.sections[sectionIndex]
        ?.widgets[widgetIndex]?.stored_in_reserved_data
        ? updateScreen?.sections[sectionIndex]?.widgets[widgetIndex]
            ?.stored_in_reserved_data
        : false;
      if (removePresistGraphData === false && !isRefreshEvent) {
        delete updateScreen?.sections[sectionIndex]?.widgets[widgetIndex]
          ?.persist_graphdata;
      }
      update_widget_list = updateScreen.sections[sectionIndex].widgets;
    } else if (
      updateScreen?.section &&
      updateScreen?.section?.[0]?.widgets?.[widgetIndex]
    ) {
      delete updateScreen?.section[0].widgets[widgetIndex]?.graphData;
      const removePresistGraphData = updateScreen?.section[0].widgets[
        widgetIndex
      ]?.stored_in_reserved_data
        ? updateScreen?.section[0].widgets[widgetIndex]?.stored_in_reserved_data
        : false;
      if (removePresistGraphData === false && !isRefreshEvent) {
        delete updateScreen?.section[0].widgets[widgetIndex]?.persist_graphdata;
      }
      update_widget_list = updateScreen?.section[0].widgets;
    } else if (updateScreen?.widgets && updateScreen?.widgets?.[widgetIndex]) {
      delete updateScreen?.widgets[widgetIndex]?.graphData;
      // Make it conditional based
      const removePresistGraphData = updateScreen?.widgets[widgetIndex]
        ?.stored_in_reserved_data
        ? updateScreen?.widgets[widgetIndex]?.stored_in_reserved_data
        : updateScreen?.widgets[widgetIndex]?.oldGraphData
        ? true
        : false;
      if (
        !presistDataStored &&
        removePresistGraphData === false &&
        !isRefreshEvent
      ) {
        delete updateScreen?.widgets[widgetIndex]?.persist_graphdata;
      }
      update_widget_list = updateScreen?.widgets;
    }
  } else if (operation === "UPDATE") {
    if (
      sectionIndex !== null &&
      updateScreen?.sections &&
      updateScreen?.sections?.[sectionIndex]?.widgets?.[widgetIndex]
    ) {
      let widgetData =
        updateScreen?.sections?.[sectionIndex]?.widgets?.[widgetIndex];
      if (widgetData?.stored_in_reserved_data) {
        widgetData.reserved_data = graphData;
        if (updateScreen?.screen_id !== "000-000-554") {
          widgetData.graphData = graphData;
          widgetData.persist_graphdata = graphData;
        }
      } else {
        widgetData.graphData = graphData;
        widgetData.persist_graphdata = graphData;
      }
      widgetData.payload = body;
      widgetData.insights = null;
      widgetData.pagination = widgetData?.pagination
        ? {
            ...widgetData?.pagination,
            current: 1,
            pageSize: widgetData?.widget_id === "000-100-907" ? 14 : 8,
          }
        : null;
      widgetData.open = false;
      widgetData.profile_filters = body?.profile_filters;

      if (
        typeof graphData !== "string" &&
        widgetData?.stored_in_reserved_data === false
      ) {
        widgetData.graphData.id = uuid();
      } else if (
        typeof graphData !== "string" &&
        widgetData?.stored_in_reserved_data
      ) {
        widgetData.reserved_data.id = uuid();
      }
      updateScreen.sections[sectionIndex].widgets[widgetIndex] = {
        ...widgetData,
      };
      update_widget_list = updateScreen.sections[sectionIndex].widgets;
    } else if (
      updateScreen?.section &&
      updateScreen?.section?.[0]?.widgets?.[widgetIndex]
    ) {
      let widgetData = updateScreen?.section?.[0]?.widgets?.[widgetIndex];
      if (widgetData?.stored_in_reserved_data) {
        widgetData.reserved_data = graphData;
        if (updateScreen?.screen_id !== "000-000-554") {
          widgetData.graphData = graphData;
          widgetData.persist_graphdata = graphData;
        }
      } else {
        widgetData.graphData = graphData;
        widgetData.persist_graphdata = graphData;
      }
      widgetData.payload = body;
      widgetData.insights = null;
      widgetData.pagination = widgetData?.pagination
        ? {
            ...widgetData?.pagination,
            current: 1,
            pageSize: widgetData?.widget_id === "000-100-907" ? 14 : 8,
          }
        : null;
      widgetData.open = false;
      widgetData.profile_filters = body?.profile_filters;

      if (
        typeof graphData !== "string" &&
        widgetData?.stored_in_reserved_data === false
      ) {
        widgetData.graphData.id = uuid();
      } else if (
        typeof graphData !== "string" &&
        widgetData?.stored_in_reserved_data
      ) {
        widgetData.reserved_data.id = uuid();
      }
      updateScreen.section[0].widgets[widgetIndex] = { ...widgetData };
      update_widget_list = updateScreen?.section[0].widgets;
    } else if (updateScreen?.widgets && updateScreen?.widgets?.[widgetIndex]) {
      let widgetData = updateScreen?.widgets?.[widgetIndex];

      let updatedObj = {};
      if (
        (window?.location?.pathname?.split?.("/")?.[3] === "000-000-565" &&
          widgetData?.widget_id === "000-100-993") ||
        (window?.location?.pathname?.split?.("/")?.[3] === "000-000-562" &&
          widgetData?.widget_id === "000-100-983") ||
        (window?.location?.pathname?.split?.("/")?.[3] === "000-000-557" &&
          widgetData?.widget_id === "000-100-979")
      ) {
        let mergedDataArray = [];
        if (widgetData?.oldGraphData) {
          let oldGraphData =
            widgetData?.oldGraphData?.data?.[`custom-card`]?.[0]?.data;
          let updatedGraphData = graphData?.data?.[`custom-card`]?.[0]?.data;
          mergedDataArray = [...oldGraphData, ...updatedGraphData];
        }
        // console.log("mergedDataArray", mergedDataArray);

        updatedObj = {
          data: {
            [`custom-card`]: [
              {
                [`filter-pills`]:
                  graphData?.data?.[`custom-card`]?.[0]?.[`filter-pills`],
                data: mergedDataArray,
              },
            ],
          },
        };
      }

      if (
        (window?.location?.pathname?.split?.("/")?.[3] === "000-000-565" &&
          widgetData?.widget_id === "000-100-993") ||
        (window?.location?.pathname?.split?.("/")?.[3] === "000-000-562" &&
          widgetData?.widget_id === "000-100-983") ||
        (window?.location?.pathname?.split?.("/")?.[3] === "000-000-557" &&
          widgetData?.widget_id === "000-100-979")
      ) {
        if (widgetData?.oldGraphData) {
          widgetData.graphData = updatedObj;
          widgetData.persist_graphdata = updatedObj;
        } else {
          widgetData.graphData = graphData;
          widgetData.persist_graphdata = graphData;

          // widgetData.graphData = "No Data Found";
          // widgetData.persist_graphdata = "No Data Found";
        }
      } else if (widgetData?.stored_in_reserved_data) {
        widgetData.reserved_data = graphData;
        if (updateScreen?.screen_id !== "000-000-554") {
          widgetData.graphData = graphData;
          widgetData.persist_graphdata = graphData;
        }
      } else {
        widgetData.graphData = graphData;
        widgetData.persist_graphdata = graphData;
      }

      widgetData.payload = body;
      widgetData.insights = null;
      widgetData.pagination = widgetData?.pagination
        ? {
            ...widgetData?.pagination,
            current: 1,
            pageSize: widgetData?.widget_id === "000-100-907" ? 14 : 8,
          }
        : null;
      widgetData.open = false;
      widgetData.profile_filters = body?.profile_filters;
      if (
        typeof graphData !== "string" &&
        widgetData?.stored_in_reserved_data === false
      ) {
        widgetData.graphData.id = uuid();
      } else if (
        typeof graphData !== "string" &&
        widgetData?.stored_in_reserved_data
      ) {
        widgetData.reserved_data.id = uuid();
      }

      updateScreen.widgets[widgetIndex] = { ...widgetData };
      update_widget_list = updateScreen?.widgets;
    }
  } else if (operation === "NOT_DELETE_SELECTED_WIDGET_ID") {
    update_widget_list = updateScreen?.widgets?.map((wid) => {
      if (wid?.widget_id !== widget_id) {
        delete wid?.graphData;
      }
      return wid;
    });
  }
  return update_widget_list;
};
export const getUpdatedScreenWidgetMetaDataList = (
  screen,
  sectionIndex,
  widgetIndex,
  operation,
  metadata,
  sectionId
) => {
  const updateScreen = screen ? { ...screen } : {};
  let update_widget_list = [];
  if (operation === "UPDATE") {
    if (
      sectionIndex !== null &&
      updateScreen?.sections &&
      updateScreen?.sections?.[sectionIndex]?.widgets?.[widgetIndex]
    ) {
      updateScreen.sections[sectionIndex].widgets[widgetIndex] = {
        ...metadata,
      };
      update_widget_list = updateScreen.sections[sectionIndex].widgets;
    } else if (
      updateScreen?.section &&
      updateScreen?.section?.[0]?.widgets?.[widgetIndex]
    ) {
      updateScreen.section[0].widgets[widgetIndex] = { ...metadata };
      update_widget_list = updateScreen?.section[0].widgets;
    } else if (updateScreen?.widgets && updateScreen?.widgets?.[widgetIndex]) {
      updateScreen.widgets[widgetIndex] = { ...metadata };
      update_widget_list = updateScreen?.widgets;
    }
  }
  return update_widget_list;
};
export const getUpdatedScreenWidgetListWithXAxis = (
  screen,
  sectionIndex,
  widgetIndex,
  operation,
  propName,
  propValue,
  graphConditions
) => {
  const updateScreen = screen ? { ...screen } : {};
  let update_widget_list = [];
  if (operation === "ALL_CLEAR") {
    if (
      sectionIndex !== null &&
      updateScreen?.sections &&
      updateScreen?.sections?.[sectionIndex]?.widgets?.length > 0
    ) {
      update_widget_list = updateScreen.sections[sectionIndex].widgets?.map(
        (wid) => {
          let widgetData = { ...wid };
          let propData = { ...widgetData?.[propName] };
          let isRadiusAttributeAllowed = false;
          if (
            (widgetData?.chart?.chart_type === "network-graph" ||
              widgetData?.chart?.chart_type === "network-graph-v2") &&
            propName === "x_axis" &&
            propValue?.radius_attribute
          ) {
            isRadiusAttributeAllowed = graphConditions?.["network-graph"]
              ?.order_by?.exclude?.[propData?.attribute?.toLowerCase()]
              ? !graphConditions?.["network-graph"]?.order_by?.exclude?.[
                  propData?.attribute?.toLowerCase()
                ]?.includes(propValue?.radius_attribute?.toLowerCase())
              : true;
          } else {
            isRadiusAttributeAllowed = true;
          }

          if (isRadiusAttributeAllowed && propName === "y_axes") {
            widgetData[propName][0].y_limit = propValue?.y_limit;

            delete widgetData?.graphData;
            delete widgetData?.persist_graphdata;
          } else if (isRadiusAttributeAllowed) {
            widgetData[propName] = {
              ...propData,
              ...propValue,
            };
            delete widgetData?.graphData;
            delete widgetData?.persist_graphdata;
          } else {
            // callNotification(
            //   "This size of attribute is not compitable with x_axis attribute",
            //   "error"
            // );
          }
          return widgetData;
        }
      );
    } else if (
      updateScreen?.section &&
      updateScreen?.section?.[0]?.widgets?.length > 0
    ) {
      update_widget_list = updateScreen?.section[0].widgets?.map((wid) => {
        let widgetData = { ...wid };
        let propData = { ...widgetData?.[propName] };
        let isRadiusAttributeAllowed = false;
        if (
          (widgetData?.chart?.chart_type === "network-graph" ||
            widgetData?.chart?.chart_type === "network-graph-v2") &&
          propName === "x_axis" &&
          propValue?.radius_attribute
        ) {
          isRadiusAttributeAllowed = graphConditions?.["network-graph"]
            ?.order_by?.exclude?.[propData?.attribute?.toLowerCase()]
            ? !graphConditions?.["network-graph"]?.order_by?.exclude?.[
                propData?.attribute?.toLowerCase()
              ]?.includes(propValue?.radius_attribute?.toLowerCase())
            : true;
        } else {
          isRadiusAttributeAllowed = true;
        }
        if (isRadiusAttributeAllowed && propName === "y_axes") {
          widgetData[propName][0].y_limit = propValue?.y_limit;

          delete widgetData?.graphData;
          delete widgetData?.persist_graphdata;
        } else if (isRadiusAttributeAllowed) {
          widgetData[propName] = {
            ...propData,
            ...propValue,
          };
          delete widgetData?.graphData;
          delete widgetData?.persist_graphdata;
        } else {
          // callNotification(
          //   "This size of attribute is not compitable with x_axis attribute",
          //   "error"
          // );
        }
        return widgetData;
      });
    } else if (updateScreen?.widgets && updateScreen?.widgets?.length > 0) {
      update_widget_list = updateScreen?.widgets?.map((wid) => {
        let widgetData = { ...wid };
        let propData = { ...widgetData?.[propName] };
        let isRadiusAttributeAllowed = false;
        if (
          (widgetData?.chart?.chart_type === "network-graph" ||
            widgetData?.chart?.chart_type === "network-graph-v2") &&
          propName === "x_axis" &&
          propValue?.radius_attribute
        ) {
          isRadiusAttributeAllowed = graphConditions?.["network-graph"]
            ?.order_by?.exclude?.[propData?.attribute?.toLowerCase()]
            ? !graphConditions?.["network-graph"]?.order_by?.exclude?.[
                propData?.attribute?.toLowerCase()
              ]?.includes(propValue?.radius_attribute?.toLowerCase())
            : true;
        } else {
          isRadiusAttributeAllowed = true;
        }
        if (isRadiusAttributeAllowed && propName === "y_axes") {
          widgetData[propName][0].y_limit = propValue?.y_limit;

          delete widgetData?.graphData;
          delete widgetData?.persist_graphdata;
        } else if (isRadiusAttributeAllowed) {
          widgetData[propName] = {
            ...propData,
            ...propValue,
          };
          delete widgetData?.graphData;
          delete widgetData?.persist_graphdata;
        } else {
          // callNotification(
          //   "This size of attribute is not compitable with x_axis attribute",
          //   "error"
          // );
        }

        return widgetData;
      });
    }
  } else if (operation === "CLEAR") {
    if (
      sectionIndex !== null &&
      updateScreen?.sections &&
      updateScreen?.sections?.[sectionIndex]?.widgets?.[widgetIndex]
    ) {
      let widgetData = {
        ...updateScreen?.section?.[sectionIndex]?.widgets?.[widgetIndex],
      };
      let propData = { ...widgetData?.[propName] };
      widgetData[propName] = {
        ...propData,
        ...propValue,
      };
      delete widgetData?.graphData;
      delete widgetData?.persist_graphdata;

      updateScreen.section[sectionIndex].widgets[widgetIndex] = {
        ...widgetData,
      };
      update_widget_list = updateScreen?.section?.[sectionIndex]?.widgets;
    } else if (
      updateScreen?.section &&
      updateScreen?.section?.[0]?.widgets?.[widgetIndex]
    ) {
      let widgetData = {
        ...updateScreen?.section?.[0]?.widgets?.[widgetIndex],
      };
      let propData = { ...widgetData?.[propName] };
      widgetData[propName] = {
        ...propData,
        ...propValue,
      };
      delete widgetData?.graphData;
      delete widgetData?.persist_graphdata;

      updateScreen.section[0].widgets[widgetIndex] = { ...widgetData };
      update_widget_list = updateScreen?.section?.[0]?.widgets;
    } else if (updateScreen?.widgets && updateScreen?.widgets?.[widgetIndex]) {
      let widgetData = { ...updateScreen?.widgets?.[widgetIndex] };
      let propData = { ...widgetData?.[propName] };
      widgetData[propName] = {
        ...propData,
        ...propValue,
      };
      delete widgetData?.graphData;
      delete widgetData?.persist_graphdata;
      updateScreen.widgets[widgetIndex] = { ...widgetData };
      update_widget_list = updateScreen?.widgets;
    }
  }
  return update_widget_list;
};
export const getUpdatedScreenWidgetListWithChartSettings = (
  screen,
  sectionIndex,
  widgetIndex,
  operation,
  propName,
  propValue
) => {
  const updateScreen = screen ? { ...screen } : {};
  let update_widget_list = [];
  if (operation === "ALL_CLEAR") {
    if (
      sectionIndex !== null &&
      updateScreen?.sections &&
      updateScreen?.sections?.[sectionIndex]?.widgets?.length > 0
    ) {
      update_widget_list = updateScreen.sections[sectionIndex].widgets?.map(
        (wid) => {
          let widgetData = { ...wid };
          if (propName === "wordcloud_color") {
            if (
              widgetData?.chart?.chart_type === "wordcloud" ||
              widgetData?.chart?.chart_type === "network-graph" ||
              widgetData?.chart?.chart_type === "network-graph-v2"
            ) {
              let updatedChartSettings = {
                ...widgetData?.chart?.chart_settings,
                [propName]: propValue,
              };
              widgetData.chart.chart_settings = updatedChartSettings;
              delete widgetData?.graphData;
              delete widgetData?.persist_graphdata;
            }
          } else {
            let updatedChartSettings = {
              ...widgetData?.chart?.chart_settings,
              [propName]: propValue,
            };
            widgetData.chart.chart_settings = updatedChartSettings;
            delete widgetData?.graphData;
            delete widgetData?.persist_graphdata;
          }
          return widgetData;
        }
      );
    } else if (
      updateScreen?.section &&
      updateScreen?.section?.[0]?.widgets?.length > 0
    ) {
      update_widget_list = updateScreen?.section[0].widgets?.map((wid) => {
        let widgetData = { ...wid };
        if (propName === "wordcloud_color") {
          if (
            widgetData?.chart?.chart_type === "wordcloud" ||
            widgetData?.chart?.chart_type === "network-graph" ||
            widgetData?.chart?.chart_type === "network-graph-v2"
          ) {
            let updatedChartSettings = {
              ...widgetData?.chart?.chart_settings,
              [propName]: propValue,
            };
            widgetData.chart.chart_settings = updatedChartSettings;
            delete widgetData?.graphData;
            delete widgetData?.persist_graphdata;
          }
        } else {
          let updatedChartSettings = {
            ...widgetData?.chart?.chart_settings,
            [propName]: propValue,
          };
          widgetData.chart.chart_settings = updatedChartSettings;
          delete widgetData?.graphData;
          delete widgetData?.persist_graphdata;
        }
        return widgetData;
      });
    } else if (updateScreen?.widgets && updateScreen?.widgets?.length > 0) {
      update_widget_list = updateScreen?.widgets?.map((wid) => {
        let widgetData = { ...wid };
        if (propName === "wordcloud_color") {
          if (
            widgetData?.chart?.chart_type === "wordcloud" ||
            widgetData?.chart?.chart_type === "network-graph" ||
            widgetData?.chart?.chart_type === "network-graph-v2"
          ) {
            let updatedChartSettings = {
              ...widgetData?.chart?.chart_settings,
              [propName]: propValue,
            };
            widgetData.chart.chart_settings = updatedChartSettings;
            delete widgetData?.graphData;
            delete widgetData?.persist_graphdata;
          }
        } else {
          let updatedChartSettings = {
            ...widgetData?.chart?.chart_settings,
            [propName]: propValue,
          };
          widgetData.chart.chart_settings = updatedChartSettings;
          delete widgetData?.graphData;
          delete widgetData?.persist_graphdata;
        }
        return widgetData;
      });
    }
  }
  return update_widget_list;
};
export const getUpdatedScreenWidgetListWithProp = (
  screen,
  sectionIndex,
  widgetIndex,
  updatedProp
) => {
  const updateScreen = screen ? { ...screen } : {};
  let update_widget_list = [];
  if (
    sectionIndex !== null &&
    updateScreen?.sections &&
    updateScreen?.sections?.[sectionIndex]?.widgets?.[widgetIndex]
  ) {
    let widgetData =
      updateScreen?.sections?.[sectionIndex]?.widgets?.[widgetIndex];
    if (updatedProp && Array.isArray(updatedProp)) {
      updatedProp?.forEach((propData) => {
        widgetData[propData?.prop_name] = propData?.prop_value
          ? Array.isArray(propData?.prop_value)
            ? [...propData?.prop_value]
            : typeof propData?.prop_value === "object"
            ? { ...propData?.prop_value }
            : propData?.prop_value
          : propData?.prop_value;
      });
    } else {
      widgetData[updatedProp?.prop_name] = updatedProp?.prop_value
        ? Array.isArray(updatedProp?.prop_value)
          ? [...updatedProp?.prop_value]
          : typeof updatedProp?.prop_value === "object"
          ? { ...updatedProp?.prop_value }
          : updatedProp?.prop_value
        : updatedProp?.prop_value;
    }
    updateScreen.sections[sectionIndex].widgets[widgetIndex] = widgetData
      ? deepCopy(widgetData)
      : {
          ...widgetData,
        };
    update_widget_list = updateScreen.sections[sectionIndex].widgets;
  } else if (
    updateScreen?.section &&
    updateScreen?.section?.[0]?.widgets?.[widgetIndex]
  ) {
    let widgetData = updateScreen?.section?.[0]?.widgets?.[widgetIndex];
    if (updatedProp && Array.isArray(updatedProp)) {
      updatedProp?.forEach((propData) => {
        widgetData[propData?.prop_name] = propData?.prop_value
          ? Array.isArray(propData?.prop_value)
            ? [...propData?.prop_value]
            : typeof propData?.prop_value === "object"
            ? { ...propData?.prop_value }
            : propData?.prop_value
          : propData?.prop_value;
      });
    } else {
      widgetData[updatedProp?.prop_name] = updatedProp?.prop_value
        ? Array.isArray(updatedProp?.prop_value)
          ? [...updatedProp?.prop_value]
          : typeof updatedProp?.prop_value === "object"
          ? { ...updatedProp?.prop_value }
          : updatedProp?.prop_value
        : updatedProp?.prop_value;
    }
    updateScreen.section[0].widgets[widgetIndex] = widgetData
      ? deepCopy(widgetData)
      : { ...widgetData };
    update_widget_list = updateScreen?.section[0].widgets;
  } else if (updateScreen?.widgets && updateScreen?.widgets?.[widgetIndex]) {
    let widgetData = updateScreen?.widgets?.[widgetIndex];
    if (updatedProp && Array.isArray(updatedProp)) {
      updatedProp?.forEach((propData) => {
        widgetData[propData?.prop_name] = propData?.prop_value
          ? Array.isArray(propData?.prop_value)
            ? [...propData?.prop_value]
            : typeof propData?.prop_value === "object"
            ? { ...propData?.prop_value }
            : propData?.prop_value
          : propData?.prop_value;
      });
    } else {
      widgetData[updatedProp?.prop_name] = updatedProp?.prop_value
        ? Array.isArray(updatedProp?.prop_value)
          ? [...updatedProp?.prop_value]
          : typeof updatedProp?.prop_value === "object"
          ? { ...updatedProp?.prop_value }
          : updatedProp?.prop_value
        : updatedProp?.prop_value;
    }
    updateScreen.widgets[widgetIndex] = widgetData
      ? deepCopy(widgetData)
      : { ...widgetData };
    update_widget_list = updateScreen?.widgets;
  }
  return update_widget_list;
};
export const getUpdatedScreenWidgetListWithPropAndClearGraphData = (
  screen,
  sectionIndex,
  widgetIndex,
  updatedProp,
  isNeedToUpdateAllWidgetWithSameId,
  presistDataStored = false
) => {
  const updateScreen = screen ? { ...screen } : {};
  let update_widget_list = [];
  if (isNeedToUpdateAllWidgetWithSameId) {
    if (
      sectionIndex !== null &&
      updateScreen?.sections &&
      updateScreen?.sections?.[sectionIndex]?.widgets
    ) {
      let widgets = updateScreen?.sections?.[sectionIndex]?.widgets;
      let updatedWidgets =
        widgets &&
        Array.isArray(widgets) &&
        widgets?.map((widgetData, wid_index) => {
          if (
            isNeedToUpdateAllWidgetWithSameId === widgetData?.parentId ||
            isNeedToUpdateAllWidgetWithSameId === widgetData?.childId ||
            isNeedToUpdateAllWidgetWithSameId === widgetData?.widgetId
          ) {
            if (updatedProp && Array.isArray(updatedProp)) {
              updatedProp?.forEach((propData) => {
                widgetData[propData?.prop_name] = propData?.prop_value
                  ? Array.isArray(propData?.prop_value)
                    ? [...propData?.prop_value]
                    : typeof propData?.prop_value === "object"
                    ? { ...propData?.prop_value }
                    : propData?.prop_value
                  : propData?.prop_value;
              });
            } else {
              widgetData[updatedProp?.prop_name] = updatedProp?.prop_value
                ? Array.isArray(updatedProp?.prop_value)
                  ? [...updatedProp?.prop_value]
                  : typeof updatedProp?.prop_value === "object"
                  ? { ...updatedProp?.prop_value }
                  : updatedProp?.prop_value
                : updatedProp?.prop_value;
            }
            delete widgetData?.graphData;
            if (!presistDataStored) {
              delete widgetData?.persist_graphdata;
            }
          }
          return { ...widgetData };
        });

      updateScreen.sections[sectionIndex].widgets =
        updatedWidgets?.length > 0 ? [...updatedWidgets] : [];
      update_widget_list = updateScreen.sections[sectionIndex].widgets;
    } else if (updateScreen?.section && updateScreen?.section?.[0]?.widgets) {
      let widgets = updateScreen?.section?.[0]?.widgets;
      let updatedWidgets =
        widgets &&
        Array.isArray(widgets) &&
        widgets?.map((widgetData, wid_index) => {
          if (
            isNeedToUpdateAllWidgetWithSameId === widgetData?.parentId ||
            isNeedToUpdateAllWidgetWithSameId === widgetData?.childId ||
            isNeedToUpdateAllWidgetWithSameId === widgetData?.widgetId
          ) {
            if (updatedProp && Array.isArray(updatedProp)) {
              updatedProp?.forEach((propData) => {
                widgetData[propData?.prop_name] = propData?.prop_value
                  ? Array.isArray(propData?.prop_value)
                    ? [...propData?.prop_value]
                    : typeof propData?.prop_value === "object"
                    ? { ...propData?.prop_value }
                    : propData?.prop_value
                  : propData?.prop_value;
              });
            } else {
              widgetData[updatedProp?.prop_name] = updatedProp?.prop_value
                ? Array.isArray(updatedProp?.prop_value)
                  ? [...updatedProp?.prop_value]
                  : typeof updatedProp?.prop_value === "object"
                  ? { ...updatedProp?.prop_value }
                  : updatedProp?.prop_value
                : updatedProp?.prop_value;
            }
            if (!presistDataStored) {
              delete widgetData?.persist_graphdata;
            }
            delete widgetData?.graphData;
          }

          return { ...widgetData };
        });

      updateScreen.section[0].widgets =
        updatedWidgets?.length > 0 ? [...updatedWidgets] : [];
      update_widget_list = updateScreen.section[0].widgets;
    } else if (updateScreen?.widgets) {
      let widgets = updateScreen?.widgets;
      let updatedWidgets =
        widgets &&
        Array.isArray(widgets) &&
        widgets?.map((widgetData, wid_index) => {
          if (
            isNeedToUpdateAllWidgetWithSameId === widgetData?.parentId ||
            isNeedToUpdateAllWidgetWithSameId === widgetData?.childId ||
            isNeedToUpdateAllWidgetWithSameId === widgetData?.widgetId
          ) {
            if (updatedProp && Array.isArray(updatedProp)) {
              updatedProp?.forEach((propData) => {
                widgetData[propData?.prop_name] = propData?.prop_value
                  ? Array.isArray(propData?.prop_value)
                    ? [...propData?.prop_value]
                    : typeof propData?.prop_value === "object"
                    ? { ...propData?.prop_value }
                    : propData?.prop_value
                  : propData?.prop_value;
              });
            } else {
              widgetData[updatedProp?.prop_name] = updatedProp?.prop_value
                ? Array.isArray(updatedProp?.prop_value)
                  ? [...updatedProp?.prop_value]
                  : typeof updatedProp?.prop_value === "object"
                  ? { ...updatedProp?.prop_value }
                  : updatedProp?.prop_value
                : updatedProp?.prop_value;
            }
            delete widgetData?.graphData;
            if (!presistDataStored) {
              delete widgetData?.persist_graphdata;
            }
          }
          return { ...widgetData };
        });

      updateScreen.widgets =
        updatedWidgets?.length > 0 ? [...updatedWidgets] : [];
      update_widget_list = updateScreen?.widgets;
    }
  } else {
    // to update seperate widget
    if (
      sectionIndex !== null &&
      updateScreen?.sections &&
      updateScreen?.sections?.[sectionIndex]?.widgets?.[widgetIndex]
    ) {
      let widgetData =
        updateScreen?.sections?.[sectionIndex]?.widgets?.[widgetIndex];

      if (updatedProp && Array.isArray(updatedProp)) {
        updatedProp?.forEach((propData) => {
          widgetData[propData?.prop_name] = propData?.prop_value
            ? Array.isArray(propData?.prop_value)
              ? [...propData?.prop_value]
              : typeof propData?.prop_value === "object"
              ? { ...propData?.prop_value }
              : propData?.prop_value
            : propData?.prop_value;
        });
      } else {
        widgetData[updatedProp?.prop_name] = updatedProp?.prop_value
          ? Array.isArray(updatedProp?.prop_value)
            ? [...updatedProp?.prop_value]
            : typeof updatedProp?.prop_value === "object"
            ? { ...updatedProp?.prop_value }
            : updatedProp?.prop_value
          : updatedProp?.prop_value;
      }
      if (!presistDataStored) {
        delete widgetData?.persist_graphdata;
      }
      delete widgetData?.graphData;
      updateScreen.sections[sectionIndex].widgets[widgetIndex] = {
        ...widgetData,
      };
      update_widget_list = updateScreen.sections[sectionIndex].widgets;
    } else if (
      updateScreen?.section &&
      updateScreen?.section?.[0]?.widgets?.[widgetIndex]
    ) {
      let widgetData = updateScreen?.section?.[0]?.widgets?.[widgetIndex];
      if (updatedProp && Array.isArray(updatedProp)) {
        updatedProp?.forEach((propData) => {
          widgetData[propData?.prop_name] = propData?.prop_value
            ? Array.isArray(propData?.prop_value)
              ? [...propData?.prop_value]
              : typeof propData?.prop_value === "object"
              ? { ...propData?.prop_value }
              : propData?.prop_value
            : propData?.prop_value;
        });
      } else {
        widgetData[updatedProp?.prop_name] = updatedProp?.prop_value
          ? Array.isArray(updatedProp?.prop_value)
            ? [...updatedProp?.prop_value]
            : typeof updatedProp?.prop_value === "object"
            ? { ...updatedProp?.prop_value }
            : updatedProp?.prop_value
          : updatedProp?.prop_value;
      }
      delete widgetData?.graphData;
      if (!presistDataStored) {
        delete widgetData?.persist_graphdata;
      }
      updateScreen.section[0].widgets[widgetIndex] = { ...widgetData };
      update_widget_list = updateScreen?.section[0].widgets;
    } else if (updateScreen?.widgets && updateScreen?.widgets?.[widgetIndex]) {
      let widgetData = updateScreen?.widgets?.[widgetIndex];
      if (updatedProp && Array.isArray(updatedProp)) {
        updatedProp?.forEach((propData) => {
          widgetData[propData?.prop_name] = propData?.prop_value
            ? Array.isArray(propData?.prop_value)
              ? [...propData?.prop_value]
              : typeof propData?.prop_value === "object"
              ? { ...propData?.prop_value }
              : propData?.prop_value
            : propData?.prop_value;
        });
      } else {
        widgetData[updatedProp?.prop_name] = updatedProp?.prop_value
          ? Array.isArray(updatedProp?.prop_value)
            ? [...updatedProp?.prop_value]
            : typeof updatedProp?.prop_value === "object"
            ? { ...updatedProp?.prop_value }
            : updatedProp?.prop_value
          : updatedProp?.prop_value;
      }

      delete widgetData?.graphData;
      if (!presistDataStored) {
        delete widgetData?.persist_graphdata;
      }
      updateScreen.widgets[widgetIndex] = { ...widgetData };
      update_widget_list = updateScreen?.widgets;
    }
  }
  return update_widget_list;
};

export const setScreenDeepDiveWidgetData = (
  value,
  screen,
  tabName,
  shareBrands,
  shareTemplateData
) => {
  const updateScreen = shareBrands ? { ...shareTemplateData } : { ...screen };
  let arr = shareBrands
    ? [...updateScreen?.deep_dive[tabName], value]
    : tabName === "influencers" || tabName === "locations"
    ? [value]
    : [...updateScreen?.deep_dive[tabName], value];

  let sortedCloud = shareTemplateData?.deep_dive?.wordcloud
    ? shareTemplateData?.deep_dive?.wordcloud
    : updateScreen?.deep_dive?.wordcloud
    ? updateScreen?.deep_dive?.wordcloud
    : [];

  let sortedCategory = shareTemplateData?.deep_dive?.category
    ? shareTemplateData?.deep_dive?.category
    : updateScreen?.deep_dive?.category
    ? updateScreen?.deep_dive?.category
    : [];

  let sortedSourceOfPost = shareTemplateData?.deep_dive?.source_of_post
    ? shareTemplateData?.deep_dive?.source_of_post
    : updateScreen?.deep_dive?.source_of_post
    ? updateScreen?.deep_dive?.source_of_post
    : [];

  if (tabName === "wordcloud") {
    if (value?.widget_id === "2.1") {
      sortedCloud[0] = value;
    } else if (value?.widget_id === "2.2") {
      sortedCloud[1] = value;
    } else if (value?.widget_id === "2.3") {
      sortedCloud[2] = value;
    } else if (value?.widget_id === "2.4") {
      sortedCloud[3] = value;
    }
  }

  if (tabName === "category") {
    if (
      value?.result?.graph_name === "Category" ||
      value?.graph_name === "Category"
    ) {
      sortedCategory[0] = value;
    } else if (
      value?.result?.graph_name === "Sub Category" ||
      value?.graph_name === "Sub Category"
    ) {
      sortedCategory[1] = value;
    } else if (
      value?.result?.graph_name === "Sub Sub Category" ||
      value?.graph_name === "Sub Sub Category"
    ) {
      sortedCategory[2] = value;
    } else if (
      value?.result?.graph_name === "Upper Category" ||
      value?.graph_name === "Upper Category"
    ) {
      sortedCategory[3] = value;
    }
  }

  if (tabName === "source_of_post") {
    if (
      value?.result?.graph_name === "Top Brands" ||
      value?.graph_name === "Top Brands"
    ) {
      sortedSourceOfPost[0] = value;
    } else if (
      value?.result?.graph_name === "Top 10 Channels" ||
      value?.graph_name === "Top 10 Channels"
    ) {
      sortedSourceOfPost[1] = value;
    } else if (
      value?.result?.graph_name === "Top 10 Languages" ||
      value?.graph_name === "Top 10 Languages"
    ) {
      sortedSourceOfPost[2] = value;
    } else if (
      value?.result?.graph_name === "Media Type" ||
      value?.graph_name === "Media Type"
    ) {
      sortedSourceOfPost[3] = value;
    }
  }

  return tabName === "wordcloud"
    ? sortedCloud
    : tabName === "category"
    ? sortedCategory
    : tabName === "source_of_post"
    ? sortedSourceOfPost
    : arr;
};
export const getDuplicateScreenWidgets = (
  widget,
  userBrands,
  objForTemporyWordFunctionality = null
) => {
  let singleBrands = userBrands?.brands?.length
    ? deepCopy(userBrands?.brands)
    : [];
  let compBrandList = singleBrands?.splice(0, 4);
  if (!compBrandList || !widget) return null;
  if (compBrandList?.length > 0) {
    let duplicateWidgets = [];
    compBrandList?.forEach((br, i) => {
      let newWidgetData = deepCopy(widget);
      let brIndex = -1;
      if (!(br?.brand_friendly_name && br?.brand_friendly_name?.length > 0)) {
        brIndex =
          singleBrands &&
          singleBrands?.findIndex((s) => s?.brand_id === br?.brand_id);
      }
      newWidgetData["com_brand_ids"] = [br];
      newWidgetData.widgetSingleBrandFilter = br;
      newWidgetData.span =
        widget["chart"]["chart_type"] === "post-card" ||
        widget["chart"]["chart_type"] === "author-card"
          ? "full"
          : "half";
      if (i === 0) {
        newWidgetData.originalWidgetName = deepCopy(widget["widget_name"]);
      }
      newWidgetData.widget_name =
        br?.brand_friendly_name && br?.brand_friendly_name?.length > 0
          ? widget["widget_name"] + " (" + br?.brand_friendly_name?.trim() + ")"
          : brIndex > -1 && singleBrands
          ? widget["widget_name"] +
            " (" +
            singleBrands[brIndex]["brand_friendly_name"]?.trim() +
            ")"
          : widget["chart"]["chart_type"];
      newWidgetData.duplicate_for_brands = true;
      if (i !== 0) {
        newWidgetData.widget_id = uuid();
        newWidgetData.childId = widget["widget_id"];
      } else {
        newWidgetData.parentId = widget["widget_id"];
      }
      if (objForTemporyWordFunctionality) {
        let widget_id = widget["widget_id"] + "#" + br?.brand_id;
        let word =
          objForTemporyWordFunctionality?.temporary_words?.[
            objForTemporyWordFunctionality?.template_id
          ]?.[objForTemporyWordFunctionality?.section_id]?.[widget_id]
            ?.exclude_words;
        let temp_exclude_words = word?.length ? word : null;
        newWidgetData.temp_exclude_words = temp_exclude_words;
      }
      if (newWidgetData?.graphData) {
        delete newWidgetData?.graphData;
      }
      if (newWidgetData?.data) {
        delete newWidgetData?.data;
      }
      if (newWidgetData?.persist_graphdata) {
        delete newWidgetData?.persist_graphdata;
      }
      duplicateWidgets.push(newWidgetData);
    });
    return duplicateWidgets;
  } else {
    return null;
  }
};
export const getDuplicateScreenWidgetsBasedOnData = (
  widget,
  userBrands,
  objForTemporyWordFunctionality = null
) => {
  let singleBrands = userBrands?.brands?.length
    ? deepCopy(userBrands?.brands)
    : [];
  let compBrandList = singleBrands?.splice(0, 4);

  let graphData = widget?.graphData
    ? deepCopy(widget?.graphData)
    : deepCopy(widget?.persist_graphdata);
  if (typeof graphData === "string" || !graphData) {
    return [{ ...widget }];
  } else {
    let metaWidgetGraphData =
      graphData?.data?.[
        widget?.chart?.chart_type === "horizontal-bar"
          ? "bar"
          : widget?.chart?.chart_type
      ];
    let singleGraphData = metaWidgetGraphData?.[0]?.data
      ? metaWidgetGraphData[0]?.data
      : metaWidgetGraphData;
    if (Array.isArray(singleGraphData)) {
      let duplicateWidgets = [];
      singleGraphData?.forEach((sData, i) => {
        let newWidgetData = deepCopy(widget);
        // let brIndex = -1;
        // if (!(br?.brand_friendly_name && br?.brand_friendly_name?.length > 0)) {
        //   brIndex =
        //     singleBrands &&
        //     singleBrands?.findIndex((s) => s?.brand_id === br?.brand_id);
        // }
        // newWidgetData["com_brand_ids"] = [br];
        // newWidgetData.widgetSingleBrandFilter = br;
        // newWidgetData.span =
        //   widget["chart"]["chart_type"] === "post-card" ||
        //   widget["chart"]["chart_type"] === "author-card"
        //     ? "full"
        //     : "half";
        if (i === 0) {
          newWidgetData.originalWidgetName = deepCopy(widget["widget_name"]);
        }
        newWidgetData.widget_name = sData?.x + " Share of Voice";
        // newWidgetData.duplicate_for_brands = true;
        if (i !== 0) {
          newWidgetData.widget_id = uuid();
          newWidgetData.childId = widget["widget_id"];
        } else {
          newWidgetData.parentId = widget["widget_id"];
        }
        let updatedGraphDataObj = {
          ...graphData,
          data: {
            [widget?.chart?.chart_type === "horizontal-bar"
              ? "bar"
              : widget?.chart?.chart_type]: Array.isArray(metaWidgetGraphData)
              ? [
                  {
                    ...metaWidgetGraphData[0],
                    data: sData?.data,
                    breakdown_value: sData?.x,
                  },
                ]
              : {
                  ...metaWidgetGraphData,
                  data: sData?.data,
                  breakdown_value: sData?.x,
                },
          },
        };
        newWidgetData.graphData = updatedGraphDataObj;
        // if (objForTemporyWordFunctionality) {
        //   let widget_id = widget["widget_id"] + "#" + br?.brand_id;
        //   let word =
        //     objForTemporyWordFunctionality?.temporary_words?.[
        //       objForTemporyWordFunctionality?.template_id
        //     ]?.[objForTemporyWordFunctionality?.section_id]?.[widget_id]
        //       ?.exclude_words;
        //   let temp_exclude_words = word?.length ? word : null;
        //   newWidgetData.temp_exclude_words = temp_exclude_words;
        // }

        duplicateWidgets.push(newWidgetData);
      });
      return duplicateWidgets;
    } else {
      return null;
    }
  }
  return null;
};
export const getUpdatedSplitScreenWidgetList = (
  widgetList,
  isCompetitorCheck,
  userBrands,
  objForTemporyWordFunctionality = null
) => {
  let clonedWidgetList = widgetList?.length ? [...widgetList] : [];
  let newWidgetList = [];
  if (isCompetitorCheck) {
    clonedWidgetList?.forEach((widget) => {
      let widgetLockedOnBrand =
        (widget?.is_locked &&
          widget?.brands?.length > 0 &&
          (widget?.brands?.[0]?.columns
            ? !widget?.brands?.[0]?.columns?.[0]?.competitor
            : !widget?.brands?.[0]?.competitor)) ||
        (widget?.is_locked &&
          (widget?.brand_groups?.length > 0 || widget?.brand_ids?.length > 0));
      if (
        !widgetLockedOnBrand &&
        !widget?.duplicate_for_brands &&
        widget?.chart?.["chart_type"] === "wordcloud" &&
        widget?.chart?.["chart_settings"]?.["duplicate_for_brands"]
      ) {
        if (objForTemporyWordFunctionality)
          objForTemporyWordFunctionality.widget_id = widget?.widget_id;
        let duplicateWidgets = getDuplicateScreenWidgets(
          widget,
          userBrands,
          objForTemporyWordFunctionality
        );

        if (duplicateWidgets) {
          newWidgetList = [...newWidgetList, ...duplicateWidgets];
        } else {
          newWidgetList.push(widget);
        }
      } else {
        newWidgetList.push(widget);
      }
    });
  } else {
    clonedWidgetList?.forEach((widget) => {
      if (!(widget?.childId && widget?.duplicate_for_brands)) {
        if (widget?.duplicate_for_brands && widget?.parentId) {
          if (
            objForTemporyWordFunctionality &&
            widget?.chart?.["chart_type"] === "wordcloud"
          ) {
            let widget_id = widget["widget_id"];
            let word =
              objForTemporyWordFunctionality?.temporary_words?.[
                objForTemporyWordFunctionality?.template_id
              ]?.[objForTemporyWordFunctionality?.section_id]?.[widget_id]
                ?.exclude_words;
            let temp_exclude_words = word?.length ? word : null;
            widget.temp_exclude_words = temp_exclude_words;
          }
          widget["widget_name"] = widget?.originalWidgetName;
          widget["filters"] = [];
          delete widget?.duplicate_for_brands;
          delete widget?.parentId;
          delete widget?.childId;
          delete widget?.span;
          delete widget?.originalWidgetName;
          delete widget?.com_brand_ids;
          delete widget?.widgetSingleBrandFilter;
          if (widget?.graphData) {
            delete widget?.graphData;
          }
          if (widget?.data) {
            delete widget?.data;
          }
          if (widget?.persist_graphdata) {
            delete widget?.persist_graphdata;
          }
        }
        newWidgetList.push(widget);
      }
    });
  }
  return newWidgetList;
};
export const getUpdatedScreenWidgetListBasedOnCompetitorCheck = (
  screen,
  sectionIndex,
  isCompetitorCheck,
  userBrands,
  objForTemporyWordFunctionality
) => {
  const updateScreen = screen ? { ...screen } : {};
  let update_widget_list = [];
  if (
    sectionIndex !== null &&
    updateScreen?.sections &&
    updateScreen?.sections?.[sectionIndex]?.widgets
  ) {
    let widgetList = updateScreen?.sections?.[sectionIndex]?.widgets;
    objForTemporyWordFunctionality.section_id =
      updateScreen?.sections?.[sectionIndex]?.section_id;
    let updatedWidgetLists = widgetList?.length
      ? getUpdatedSplitScreenWidgetList(
          widgetList,
          isCompetitorCheck,
          userBrands,
          objForTemporyWordFunctionality
        )
      : [];
    updateScreen.sections[sectionIndex].widgets = [...updatedWidgetLists];
    update_widget_list = updateScreen.sections[sectionIndex].widgets;
  } else if (updateScreen?.section && updateScreen?.section?.[0]?.widgets) {
    let widgetList = updateScreen?.section?.[0]?.widgets;
    objForTemporyWordFunctionality.section_id =
      updateScreen?.section?.[0]?.section_id;
    let updatedWidgetLists = widgetList?.length
      ? getUpdatedSplitScreenWidgetList(
          widgetList,
          isCompetitorCheck,
          userBrands,
          objForTemporyWordFunctionality
        )
      : [];
    updateScreen.section[0].widgets = [...updatedWidgetLists];
    update_widget_list = updateScreen?.section[0].widgets;
  } else if (updateScreen?.widgets) {
    let widgetList = updateScreen?.widgets;
    objForTemporyWordFunctionality.section_id = updateScreen?.section_id;
    let updatedWidgetLists = widgetList?.length
      ? getUpdatedSplitScreenWidgetList(
          widgetList,
          isCompetitorCheck,
          userBrands,
          objForTemporyWordFunctionality
        )
      : [];
    updateScreen.widgets = [...updatedWidgetLists];
    update_widget_list = updateScreen?.widgets;
  }
  return update_widget_list;
};
export const getUpdatedFIlterPillsForDataPool = (
  filterPills = [],
  newData = null
) => {
  let updatedFilterPills = filterPills?.length ? [...filterPills] : [];
  if (updatedFilterPills && Array.isArray(updatedFilterPills) && newData) {
    let channelName = newData?.Channel;
    if (Number.isInteger(channelName)) {
      channelName = newData?.ChannelName ? newData?.ChannelName : "";
    }
    let totalMentionCount = 0;
    let isOtherChannel = true;
    if (!Number.isInteger(channelName) && channelName) {
      updatedFilterPills?.forEach((stats) => {
        let statsChannel =
          stats?.text && stats?.text?.includes("|$|")
            ? stats?.text?.split("|$|")?.[0]?.trim()
            : null;
        totalMentionCount += parseInt(stats?.value);
        if (channelName?.toLowerCase() === statsChannel?.toLowerCase()) {
          isOtherChannel = false;
        }
      });
      totalMentionCount = parseInt(totalMentionCount + 1);
      updatedFilterPills = updatedFilterPills?.map((stats) => {
        let statsChannel =
          stats?.text && stats?.text?.includes("|$|")
            ? stats?.text?.split("|$|")?.[0]?.trim()
            : null;
        return channelName?.toLowerCase() == statsChannel?.toLowerCase() ||
          (isOtherChannel &&
            "Others"?.toLowerCase() == statsChannel?.toLowerCase())
          ? {
              ...stats,
              value: parseInt(stats?.value) + 1,
              share: parseFloat(
                ((parseInt(stats?.value) + 1) / totalMentionCount) * 100
              )?.toFixed(2),
            }
          : {
              ...stats,
              share: parseFloat(
                (parseInt(stats?.value) / totalMentionCount) * 100
              )?.toFixed(2),
            };
      });
      if (isOtherChannel) {
        updatedFilterPills?.push({
          // color: "#19bfe5",
          // highlight: true,
          percent: null,
          text: `${channelName}|$| ${channelName}`,
          value: 1,
          share: parseFloat((1 / totalMentionCount) * 100)?.toFixed(2),
        });
      }
    }
  }
  return updatedFilterPills;
};
export const getUpdatedScreenDataPool = (
  screenDataPool,
  operation,
  widget_id,
  newData
) => {
  let updatedScreenDataPool = screenDataPool ? screenDataPool : {};
  if (operation === "ADD") {
    let defaultSinglePoolValue = {
      [`filter-pills`]: [],
      data: [],
    };
    if (!updatedScreenDataPool?.[widget_id]) {
      updatedScreenDataPool[widget_id] = [defaultSinglePoolValue];
    }
    if (updatedScreenDataPool?.[widget_id]?.length === 10) {
      updatedScreenDataPool[widget_id] =
        updatedScreenDataPool[widget_id]?.slice(1);
    }
    let indexOfCurrentEmptyPool = updatedScreenDataPool?.[widget_id]?.findIndex(
      (pool) => pool?.data?.length < 12
    );
    if (indexOfCurrentEmptyPool !== -1) {
      updatedScreenDataPool?.[widget_id]?.[indexOfCurrentEmptyPool]?.data?.push(
        newData
      );
      let updatedFilterPills = getUpdatedFIlterPillsForDataPool(
        updatedScreenDataPool?.[widget_id]?.[indexOfCurrentEmptyPool]?.[
          "filter-pills"
        ]?.length > 0
          ? updatedScreenDataPool?.[widget_id]?.[indexOfCurrentEmptyPool]?.[
              "filter-pills"
            ]
          : [],
        newData
      );
      updatedScreenDataPool[widget_id][indexOfCurrentEmptyPool][
        "filter-pills"
      ] = updatedFilterPills?.length > 0 ? updatedFilterPills : [];
    } else {
      updatedScreenDataPool?.[widget_id]?.push(defaultSinglePoolValue);
      let lastIndexOfScreenPool =
        updatedScreenDataPool?.[widget_id]?.length - 1;
      updatedScreenDataPool?.[widget_id]?.[lastIndexOfScreenPool]?.data?.push(
        newData
      );
      let updatedFilterPills = getUpdatedFIlterPillsForDataPool(
        updatedScreenDataPool?.[widget_id]?.[lastIndexOfScreenPool]?.[
          "filter-pills"
        ]?.length > 0
          ? updatedScreenDataPool?.[widget_id]?.[lastIndexOfScreenPool]?.[
              "filter-pills"
            ]
          : [],
        newData
      );
      updatedScreenDataPool[widget_id][lastIndexOfScreenPool]["filter-pills"] =
        updatedFilterPills?.length > 0 ? updatedFilterPills : [];
    }
  } else if (operation === "REMOVE") {
    if (updatedScreenDataPool?.[widget_id]) {
      updatedScreenDataPool[widget_id] =
        updatedScreenDataPool[widget_id]?.slice(1);
    }
  }
  return updatedScreenDataPool;
};
export const getSimplifiedKeywordForGoogle = (keyword) => {
  // Step 1: Replace unwanted characters
  keyword = keyword?.replace(/#|''/g, "");

  // Step 2: Check if the keyword has more than one space and log if true
  if (keyword?.indexOf(" ") > 1) {
    // console.log(keyword);
  }

  // Step 3: Check if the keyword contains non-Latin characters
  const isNonLatin = /[^\u0000-\u007F]+/.test(keyword);

  // Step 4: If the keyword contains non-Latin characters and numbers, return it as-is
  const hasNumbers = /\d/.test(keyword);
  if (isNonLatin || (isNonLatin && hasNumbers)) {
    return keyword.trim();
  }

  // Step 3: Match patterns and reformat the keyword if necessary
  else if (keyword?.match(/[A-Z]*[a-z]+|[A-Z]*[A-Z]|\d+/g) !== null) {
    keyword = keyword?.match(/[A-Z]*[a-z]+|[A-Z]*[A-Z]|\d+/g)?.join(" ");
  }

  // Step 4: Return the modified keyword
  return keyword;
};
